import momentTz from 'moment-timezone';
import { Moment } from 'moment';

const getUtcOffsetForLocation = (
	timezone: string,
	date?: Date | Moment | string,
): number => {
	if (timezone == null) {
		return 0;
	}

	return momentTz.tz(date || Date.now(), timezone).utcOffset();
};

export default getUtcOffsetForLocation;
